import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background-50 px-6">
      <div className="text-center max-w-md">
        <div className="w-20 h-20 rounded-2xl bg-background-100 flex items-center justify-center mx-auto mb-6">
          <i className="ri-emotion-sad-line text-3xl text-foreground-400"></i>
        </div>
        <h1 className="font-heading text-3xl font-bold text-foreground-900 mb-3">Page Not Found</h1>
        <p className="text-sm text-foreground-600 mb-8 leading-relaxed">
          The page you are looking for does not exist or has been moved. Return to the homepage to explore our Sugargoo Spreadsheet resources.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-line"></i>
          Back to Home
        </Link>
      </div>
    </div>
  );
}